<app-public-shop-multimedia-upload
  (selectFilesEvent)="handleSelectFilesEvent($event)"
  [allowedMimeTypes]="allowedMimeTypes"
  [allowedMultimediaTypes]="allowedMultimediaTypes"
  [disabled]="disabled()"
  [maxFileSize]="maxFileSize()"
  [maxNumberOfFiles]="maxNumberOfFiles()"
  [multi]="multi()" />
